import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const ExpandIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g>
        <path d="M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"></path>
        <path d="m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"></path>
      </g>
    </StyledSVGIcon>
  );
};